import { formatCurrencyPrecise, formatDate } from '@/lib/locale'

/**
 * Shared money formatter for the report components. Any non-finite or
 * missing value collapses to $0.00 so the reports never show NaN cells.
 */
export function fmtMoney(n: unknown): string {
  const v = typeof n === 'number' ? n : Number(n)
  if (!Number.isFinite(v)) return formatCurrencyPrecise(0)
  return formatCurrencyPrecise(v)
}

export function formatLongDate(d: string | Date | null | undefined): string {
  if (!d) return ''
  // Why: callers feed us either a plain "YYYY-MM-DD" (good) or a full
  // ISO string from Postgres DATE → JSON ("2025-02-26T00:00:00.000Z"),
  // sometimes even a Date object. Slicing to the date portion first
  // and re-appending T00:00:00 forces local-zone midnight regardless
  // of input shape - without the slice, the previous code produced
  // "...T00:00:00.000ZT00:00:00" and rendered "Invalid Date".
  const s = d instanceof Date ? d.toISOString() : String(d)
  const datePart = s.slice(0, 10)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return ''
  return formatDate(datePart + 'T00:00:00', { year: 'numeric', month: 'long', day: 'numeric' })
}
